import { useState } from "react";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import { ImagePlus } from "lucide-react";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { addDoc, collection } from "firebase/firestore";
import { db, storage } from "../../../lib/firebase";
import AutocompleteInput from "../../allEvents/components/Autocomplete";
import SpinnerIcon from "../../../assets/svgs/spinner";

type FormData = {
  addressdetail: string;
  image: FileList;
  latitude: number;
  longitude: number;
  publish: boolean;
  sponsoremail: string;
  sponsorephone: string;
  sponsorname: string;
  url: string;
};

interface AddCustomAdsProps {
  open: boolean;
  onClose: () => void;
}

export default function AddCustomAds({ open, onClose }: AddCustomAdsProps) {
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [isloading, setIsLaoding] = useState<boolean>(false);
  const [addressData, setAddressData] = useState<{
    address: string;
    lat: number;
    lng: number;
  } | null>(null);
  const handleAddressSelect = (address: string, lat: number, lng: number) => {
    setAddressData({ address, lat, lng });
    console.log("Address:", address, "Latitude:", lat, "Longitude:", lng);
  };
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = async (data: FormData) => {
    if (isloading) {
      return;
    }
    if (!data.image[0]) {
      alert("Please upload an image.");
      return;
    }
    setIsLaoding(true);

    // Upload image to Firebase Storage
    const imageRef = ref(storage, `customAds/${data.image[0].name}`);
    const snapshot = await uploadBytes(imageRef, data.image[0]);
    const imageUrl = await getDownloadURL(snapshot.ref);

    // Save event data to Firestore
    await addDoc(collection(db, "bannerAdd"), {
      sponsorname: data.sponsorname,
      sponsorephone: data.sponsorephone,
      sponsoremail: data.sponsoremail,
      createddate: new Date(),
      latitude: addressData?.lat,
      addressdetail: addressData?.address,
      longitude: addressData?.lng,
      image: imageUrl,
      publish: true,
      url: data.url,
    });
    setIsLaoding(true);
    onClose(); // Close dialog
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div
      className={`modal m-2 ${
        open ? "block z-50" : "hidden"
      } fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center py-8`}
    >
      <div className="bg-bg rounded-lg shadow-lg w-full max-w-3xl max-h-[600px] flex flex-col">
        <div className="overflow-auto max-h-[70vh] p-4">
          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="border border-dashed border-gray-600 rounded-lg p-4 text-center cursor-pointer hover:bg-gray-900 relative">
              <input
                type="file"
                {...register("image", { required: "Image is required" })}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                onChange={handleImageChange}
                accept="image/*"
              />
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="max-h-40 mx-auto"
                />
              ) : (
                <div className="flex flex-col items-center gap-2">
                  <ImagePlus className="w-8 h-8 text-gray-400" />
                  <span className="text-sm text-gray-400">Add image</span>
                </div>
              )}
            </div>
            {errors.image && (
              <span className="text-red-500 text-sm">
                {errors.image.message}
              </span>
            )}
            <input
              placeholder="Enter Link"
              className="w-full px-9 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
              {...register("url", { required: "Link is required" })}
            />
            {errors.url && (
              <span className="text-red-500 text-sm">{errors.url.message}</span>
            )}

            <input
              placeholder="Enter Email"
              className="w-full px-9 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
              {...register("sponsoremail", {
                required: "Sponsor email is required",
              })}
            />
            {errors.url && (
              <span className="text-red-500 text-sm">{errors.url.message}</span>
            )}
            <input
              placeholder="Enter sponsor name"
              className="w-full px-9 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
              {...register("sponsorname", {
                required: "Sponsor name is required",
              })}
            />
            {errors.sponsorname && (
              <span className="text-red-500 text-sm">
                {errors.sponsorname.message}
              </span>
            )}
            <input
              placeholder="Enter sponsor number"
              className="w-full px-9 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
              {...register("sponsorephone", {
                required: "Sponsor phone number is required",
              })}
            />
            {errors.sponsorephone && (
              <span className="text-red-500 text-sm">
                {errors.sponsorephone.message}
              </span>
            )}

            <AutocompleteInput onAddressSelect={handleAddressSelect} />
            <div className="sticky bottom-0 z-10  flex justify-end space-x-4">
              <button
                type="button"
                onClick={onClose}
                className="bg-bgCard text-text px-4 py-2 rounded-full"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-primary text-white px-4 py-2 hover:bg-primary/50 rounded-full"
              >
                {isloading ? <SpinnerIcon /> : "Add Ads"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
